export default "__VITE_ASSET__MUNYbDS9__"